import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import DomainsList from './domainsList/index';
import AddDomain from './addDomain';
import classNames from 'classnames';
import styles from './style.scss';

@inject('translationsStore', 'windowsDomainsStore')
@observer
export default class DomainManagerSettings extends Component {

    componentDidMount() {
        this.props.windowsDomainsStore.getAllDomains();
    }

    openEditDomainManager = () => {
        this.props.windowsDomainsStore.addNewLine();
    }

    render() {
        const { showAddDomain, domains } = this.props.windowsDomainsStore;
        
        return (
            <div className={classNames(styles.generalSettingsSection)}>
                <div className={classNames(styles.generalSettingsTitle)}>
                    {this.props.translationsStore.translate('DOMAIN_MANAGMENT')}
                </div>
                <div className={classNames(styles.settingSubTitle)} data-cy='domain-management-sub-title'>
                    {this.props.translationsStore.translate('DOMAIN_MANAGMENT_SUB_TITLE') }
                </div>
                <div>
                    <DomainsList
                        domains={domains}
                        translations={{
                            DOMAIN_NAME: this.props.translationsStore.translate('DOMAIN_NAME'),
                            DNS_DOMAIN: this.props.translationsStore.translate('DNS_DOMAIN')
                        }}
                    />
                    <AddDomain
                        onClick={this.openEditDomainManager.bind(this)}
                        showAddDomain={showAddDomain}
                        firstDomain={!domains || domains.length === 0}
                        text={this.props.translationsStore.translate('ADD_NEW_DOMAIN_MANAGER')}
                    />
                </div>
            </div>
        );
    }
}